import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../lemans-app.model';
import { resetSession } from './gainsight.actions';

@Injectable({
  providedIn: 'root',
})
export class GainsightFacade {
  private readonly store$ = inject<Store<AppState>>(Store);


  resetSession(): void {
    this.store$.dispatch(resetSession());
  }
}
